<template>
  <v-dialog :width="width" class="view-msg-dialog" :title="title" :visible.sync="dialogVisible" @close="onClose"
    @closed="onClosed" split-line :scrollbar="false">
    <div v-if="data" class="view-msg-body" :class="[data.Type]">
      <template v-if="data.Type === 'image'">
        <el-image :src="data.Url" :preview-src-list="[data.Url]" :z-index="9999">
          <div slot="placeholder">
            Loading<span class="dot">...</span>
          </div>
        </el-image>
      </template>
      <template v-else-if="data.Type === 'video'">
        <video :src="data.Url" :poster="data.Poster" controlslist="nodownload" controls />
      </template>
      <template v-else-if="data.Type === 'voice'">
        <VoicePlayer :src="data.Url" />
      </template>
    </div>
  </v-dialog>
</template>
<script>
import * as _ from 'lodash'
import VoicePlayer from '../../../../components/voice-player';
export default {
  name: "view-msg-dialog",
  components: { VoicePlayer },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: false,
    },
    data: Object,
  },
  data() {
    return {
      dialogVisible: this.visible,
    };
  },
  computed: {
    title() {
      if (!this.data) return 'View Message';
      return `View ${_.upperFirst(this.data.Type)} Message - ${this.data.Message}`
    },
    width() {
      return this.data && this.data.Type === 'voice' ? '500px' : '840px'
    }
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    onClosed() {
      this.$emit("update:data", null);
      this.$emit("update:visible", false);
    },
  },
};
</script>
<style lang="scss" scoped>
.view-msg-dialog {
  &::v-deep {
    .el-dialog__body {
      padding: 20px;
    }

    .el-dialog__footer {
      padding: 0;
    }
  }

  .view-msg-body {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(800px * 9 / 16);

    &.voice {
      height: 80px;
    }
  }

  .el-image {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #C0C4CC;
  }

  video {
    width: 800px;
    height: calc(800px * 9 / 16);
    background-color: #000;
    margin: 0 auto;
  }

  audio {
    width: 100%;
  }
}
</style>
